import styled from 'styled-components';

import { Page } from 'components/shared/Layout';

export const StyledPage = styled(Page)`
  padding: 50px 100px;
`;
